export default "__VITE_ASSET__DDZjj5EZ__"